import React, { useEffect, useRef, useState } from "react";
import CoachLayout from "../../layouts/CoachLayout";
import MenuLayout from "../../layouts/MenuLayout";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { fetchCoachCategories } from "../../redux/features/coach/actions/authAction";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Learning = () => {
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const { categoryList, isLoading } = useSelector((state) => state.coach.auth);

  const user = { name: "find-a-coach", role: "coach" };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();

  const [searchByName, setSearchByName] = useState("");
  const [searchByCoachingType, setSearchByCoachingType] = useState(
    state?.data ?? ""
  );

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchCoachList());
    dispatch(fetchCoachCategories());
  }, []);

  const displayUsers = coachList?.filter((item) => {
    const matchSearchName =
      !searchByName ||
      item?.full_name?.toLowerCase().includes(searchByName.toLowerCase());
    const matchCoachingType =
      !searchByCoachingType ||
      item?.category_name
        ?.toLowerCase()
        .includes(searchByCoachingType.toLowerCase());
    return matchCoachingType && matchSearchName;
  });

  if (isLoading2 || isLoading) {
    return <Loader />;
  }
  return (
    <MenuLayout user={user}>
      {({ openSignUp }) => (
        <>
          <section
            class="ct_px_40    ct_pt_40_pb_32"
            style={{ backgroundColor: "#8ECAE6" }}
          >
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-xxl-12 col-xl-12 "
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <div className="ct_leaning_banner_grid">
                    <div>
                      <img
                        src="../assets/img/leaning_banner_img_1.png"
                        className="ct_img_h_240"
                      />
                    </div>
                    <div className="text-center ct_middle_learning_center">
                      <h2 className="ct_fs_32 text-white mb-0">
                        Level Up with Curated{" "}
                        <span className="ct_darkblue_text">Learning</span>
                      </h2>
                      <p
                        className="ct_fs_18 text-white mx-auto ct_fw_300 ct_mt_20 mb-0"
                        style={{ maxWidth: "442px" }}
                      >
                        Gain expert insights, sharpen your skills, and grow with
                        confidence.
                      </p>
                      <div
                        className="position-relative mx-auto ct_mt_30 w-100"
                        style={{ maxWidth: "390px" }}
                      >
                        <input
                          className="text"
                          class="form-control ct_input ct_input_ps_40"
                          placeholder="Search...."
                        />
                        <i class="fa-solid fa-magnifying-glass ct_input_icon_left"></i>
                      </div>
                    </div>
                    <div className="mt-auto">
                      <img
                        src="../assets/img/leaning_banner_img_2.png"
                        className="ct_img_h_240"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="ct_px_40 ct_py_100">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <ul
                    class="nav nav-pills mb-3 ct_custom_tabs3 w-100 border-0 rounded-0"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link ct_h_34 py-0 ct_border_radius_10 active"
                        id="pills-All-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-All"
                        type="button"
                        role="tab"
                        aria-controls="pills-All"
                        aria-selected="true"
                      >
                        All
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link ct_h_34 py-0 ct_border_radius_10"
                        id="pills-Web_Development-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-Web_Development"
                        type="button"
                        role="tab"
                        aria-controls="pills-Web_Development"
                        aria-selected="false"
                        tabindex="-1"
                      >
                        Web Development
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link ct_h_34 py-0 ct_border_radius_10"
                        id="pills-Rescheduled-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-Rescheduled"
                        type="button"
                        role="tab"
                        aria-controls="pills-Rescheduled"
                        aria-selected="false"
                        tabindex="-1"
                      >
                        Rescheduled
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link ct_h_34 py-0 ct_border_radius_10"
                        id="pills-UI_UX_Design-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-UI_UX_Design"
                        type="button"
                        role="tab"
                        aria-controls="pills-UI_UX_Design"
                        aria-selected="false"
                        tabindex="-1"
                      >
                        UI UX Design
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link ct_h_34 py-0 ct_border_radius_10"
                        id="pills-UI_UX_Design-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-UI_UX_Design"
                        type="button"
                        role="tab"
                        aria-controls="pills-UI_UX_Design"
                        aria-selected="false"
                        tabindex="-1"
                      >
                        Digital Marketing
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link ct_h_34 py-0 ct_border_radius_10"
                        id="pills-UI_UX_Design-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-UI_UX_Design"
                        type="button"
                        role="tab"
                        aria-controls="pills-UI_UX_Design"
                        aria-selected="false"
                        tabindex="-1"
                      >
                        Copy Writing
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link ct_h_34 py-0 ct_border_radius_10"
                        id="pills-UI_UX_Design-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-UI_UX_Design"
                        type="button"
                        role="tab"
                        aria-controls="pills-UI_UX_Design"
                        aria-selected="false"
                        tabindex="-1"
                      >
                        Graphic Design
                      </button>
                    </li>
                  </ul>

                  <div class="tab-content ct_mt_60" id="pills-tabContent">
                    <div
                      class="tab-pane fade active show"
                      id="pills-All"
                      role="tabpanel"
                      aria-labelledby="pills-All-tab"
                    >
                      <div className="row gx-5">
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0 d-grid h-100 ">
                              <div>
                                <div className="ct_learning_card_img_aspext_ratio">
                                  <img
                                    src="../assets/img/leaning_coaurce_img_1.png"
                                    className="ct_img_h_183 ct_border_radius_20"
                                  />
                                </div>
                                <figcaption className="ct_mt_33">
                                  <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                    System design in Figma
                                  </h4>
                                  <p
                                    className="mb-0"
                                    style={{ maxWidth: "350px" }}
                                  >
                                    You will learn how to create user-friendly
                                    and efficient interfaces for large systems.
                                  </p>
                                  <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        4 hours
                                      </span>
                                    </li>
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        10 hours
                                      </span>
                                    </li>
                                  </ul>
                                  <div className="ct_mt_20">
                                    <p className="text-end ct_fs_14 ct_darkblue_text">
                                      73%
                                    </p>
                                    <div class="progress ct_custom_progress ct_flex_1">
                                      <div
                                        class="progress-bar"
                                        role="progressbar"
                                        style={{
                                          width: "73%",
                                          backgroundColor: "var(--dark_blue)",
                                        }}
                                        aria-valuenow="73"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                      ></div>
                                    </div>
                                  </div>
                                </figcaption>
                              </div>
                              <div className="mt-auto">
                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button
                                    onClick={openSignUp}
                                    className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60"
                                  >
                                    Resume Course
                                  </button>
                                </div>
                              </div>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0 h-100 d-grid">
                              <div>
                                <div className="ct_learning_card_img_aspext_ratio">
                                  <img
                                    src="../assets/img/leaning_coaurce_img_2.png"
                                    className="ct_img_h_183 ct_border_radius_20"
                                  />
                                </div>
                                <figcaption className="ct_mt_33">
                                  <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                    System design in Figma
                                  </h4>
                                  <p
                                    className="mb-0"
                                    style={{ maxWidth: "350px" }}
                                  >
                                    You will learn how to create user-friendly
                                    and efficient interfaces for large systems.
                                  </p>
                                  <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        4 hours
                                      </span>
                                    </li>
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        10 hours
                                      </span>
                                    </li>
                                  </ul>
                                </figcaption>
                              </div>
                              <div className="mt-auto">
                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button
                                    onClick={openSignUp}
                                    className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60"
                                  >
                                    Start Course
                                  </button>
                                </div>
                              </div>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0 h-100 d-grid ">
                              <div>
                                <div className="ct_learning_card_img_aspext_ratio">
                                  <img
                                    src="../assets/img/leaning_coaurce_img_3.png"
                                    className="ct_img_h_183 ct_border_radius_20"
                                  />
                                </div>
                                <figcaption className="ct_mt_33">
                                  <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                    System design in Figma
                                  </h4>
                                  <p
                                    className="mb-0"
                                    style={{ maxWidth: "350px" }}
                                  >
                                    You will learn how to create user-friendly
                                    and efficient interfaces for large systems.
                                  </p>
                                  <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        4 hours
                                      </span>
                                    </li>
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        10 hours
                                      </span>
                                    </li>
                                  </ul>
                                </figcaption>
                              </div>

                              <div class="mt-auto">
                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button
                                    onClick={openSignUp}
                                    className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60"
                                  >
                                    Start Course
                                  </button>
                                </div>
                              </div>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0 d-grid h-100">
                              <div>
                                <div className="ct_learning_card_img_aspext_ratio">
                                  <img
                                    src="../assets/img/leaning_coaurce_img_4.png"
                                    className="ct_img_h_183 ct_border_radius_20"
                                  />
                                </div>
                                <figcaption className="ct_mt_33">
                                  <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                    System design in Figma
                                  </h4>
                                  <p
                                    className="mb-0"
                                    style={{ maxWidth: "350px" }}
                                  >
                                    You will learn how to create user-friendly
                                    and efficient interfaces for large systems.
                                  </p>
                                  <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        4 hours
                                      </span>
                                    </li>
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        10 hours
                                      </span>
                                    </li>
                                  </ul>
                                  <div className="ct_mt_20">
                                    <p className="text-end ct_fs_14 ct_darkblue_text">
                                      73%
                                    </p>
                                    <div class="progress ct_custom_progress ct_flex_1">
                                      <div
                                        class="progress-bar"
                                        role="progressbar"
                                        style={{
                                          width: "73%",
                                          backgroundColor: "var(--dark_blue)",
                                        }}
                                        aria-valuenow="73"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                      ></div>
                                    </div>
                                  </div>
                                </figcaption>
                              </div>
                              <div className="mt-auto">
                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button
                                    onClick={openSignUp}
                                    className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60"
                                  >
                                    Resume Course
                                  </button>
                                </div>
                              </div>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0 d-grid h-100">
                              <div>
                                <div className="ct_learning_card_img_aspext_ratio">
                                  <img
                                    src="../assets/img/leaning_coaurce_img_5.png"
                                    className="ct_img_h_183 ct_border_radius_20"
                                  />
                                </div>
                                <figcaption className="ct_mt_33">
                                  <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                    System design in Figma
                                  </h4>
                                  <p
                                    className="mb-0"
                                    style={{ maxWidth: "350px" }}
                                  >
                                    You will learn how to create user-friendly
                                    and efficient interfaces for large systems.
                                  </p>
                                  <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        4 hours
                                      </span>
                                    </li>
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        10 hours
                                      </span>
                                    </li>
                                  </ul>
                                </figcaption>
                              </div>
                              <div className="mt-auto">
                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button
                                    onClick={openSignUp}
                                    className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60"
                                  >
                                    Start Course
                                  </button>
                                </div>
                              </div>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0 d-grid h-100">
                              <div>
                                <div className="ct_learning_card_img_aspext_ratio">
                                  <img
                                    src="../assets/img/leaning_coaurce_img_1.png"
                                    className="ct_img_h_183 ct_border_radius_20"
                                  />
                                </div>
                                <figcaption className="ct_mt_33">
                                  <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                    System design in Figma
                                  </h4>
                                  <p
                                    className="mb-0"
                                    style={{ maxWidth: "350px" }}
                                  >
                                    You will learn how to create user-friendly
                                    and efficient interfaces for large systems.
                                  </p>
                                  <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        4 hours
                                      </span>
                                    </li>
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        10 hours
                                      </span>
                                    </li>
                                  </ul>
                                </figcaption>
                              </div>
                              <div className="mt-auto">
                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button
                                    onClick={openSignUp}
                                    className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60"
                                  >
                                    Start Course
                                  </button>
                                </div>
                              </div>
                            </figure>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0 h-100 d-grid">
                              <div>
                                <div className="ct_learning_card_img_aspext_ratio">
                                  <img
                                    src="../assets/img/leaning_coaurce_img_6.png"
                                    className="ct_img_h_183 ct_border_radius_20"
                                  />
                                </div>
                                <figcaption className="ct_mt_33">
                                  <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                    System design in Figma
                                  </h4>
                                  <p
                                    className="mb-0"
                                    style={{ maxWidth: "350px" }}
                                  >
                                    You will learn how to create user-friendly
                                    and efficient interfaces for large systems.
                                  </p>
                                  <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        4 hours
                                      </span>
                                    </li>
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        10 hours
                                      </span>
                                    </li>
                                  </ul>
                                  <div className="ct_mt_20">
                                    <p className="text-end ct_fs_14 ct_darkblue_text">
                                      73%
                                    </p>
                                    <div class="progress ct_custom_progress ct_flex_1">
                                      <div
                                        class="progress-bar"
                                        role="progressbar"
                                        style={{
                                          width: "73%",
                                          backgroundColor: "var(--dark_blue)",
                                        }}
                                        aria-valuenow="73"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                      ></div>
                                    </div>
                                  </div>
                                </figcaption>
                              </div>
                              <div className="mt-auto">
                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button
                                    onClick={openSignUp}
                                    className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60"
                                  >
                                    Resume Course
                                  </button>
                                </div>
                              </div>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0 h-100 d-grid">
                              <div>
                                <div className="ct_learning_card_img_aspext_ratio">
                                  <img
                                    src="../assets/img/leaning_coaurce_img_1.png"
                                    className="ct_img_h_183 ct_border_radius_20"
                                  />
                                </div>
                                <figcaption className="ct_mt_33">
                                  <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                    System design in Figma
                                  </h4>
                                  <p
                                    className="mb-0"
                                    style={{ maxWidth: "350px" }}
                                  >
                                    You will learn how to create user-friendly
                                    and efficient interfaces for large systems.
                                  </p>
                                  <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        4 hours
                                      </span>
                                    </li>
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        10 hours
                                      </span>
                                    </li>
                                  </ul>
                                </figcaption>
                              </div>
                              <div className="mt-auto">
                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button
                                    onClick={openSignUp}
                                    className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60"
                                  >
                                    Start Course
                                  </button>
                                </div>
                              </div>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0 h-100 d-grid">
                              <div>
                                <div className="ct_learning_card_img_aspext_ratio">
                                  <img
                                    src="../assets/img/leaning_coaurce_img_7.png"
                                    className="ct_img_h_183 ct_border_radius_20"
                                  />
                                </div>
                                <figcaption className="ct_mt_33">
                                  <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                    System design in Figma
                                  </h4>
                                  <p
                                    className="mb-0"
                                    style={{ maxWidth: "350px" }}
                                  >
                                    You will learn how to create user-friendly
                                    and efficient interfaces for large systems.
                                  </p>
                                  <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        4 hours
                                      </span>
                                    </li>
                                    <li>
                                      <span
                                        className="ct_badge border-0 ct_darkblue_text "
                                        style={{
                                          backgroundColor: "#DFDFDF",
                                          padding: "3px 10px",
                                        }}
                                      >
                                        10 hours
                                      </span>
                                    </li>
                                  </ul>
                                </figcaption>
                              </div>
                              <div className="mt-auto">
                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button
                                    onClick={openSignUp}
                                    className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60"
                                  >
                                    Start Course
                                  </button>
                                </div>
                              </div>
                            </figure>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="pills-Web_Development"
                      role="tabpanel"
                      aria-labelledby="pills-Web_Development-tab"
                    >
                      <div className="row gx-5">
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_1.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>
                                <div className="ct_mt_20">
                                  <p className="text-end ct_fs_14 ct_darkblue_text">
                                    73%
                                  </p>
                                  <div class="progress ct_custom_progress ct_flex_1">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: "73%",
                                        backgroundColor: "var(--dark_blue)",
                                      }}
                                      aria-valuenow="73"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    ></div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Resume Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_2.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_3.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_4.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>
                                <div className="ct_mt_20">
                                  <p className="text-end ct_fs_14 ct_darkblue_text">
                                    73%
                                  </p>
                                  <div class="progress ct_custom_progress ct_flex_1">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: "73%",
                                        backgroundColor: "var(--dark_blue)",
                                      }}
                                      aria-valuenow="73"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    ></div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Resume Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_5.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_1.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_6.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>
                                <div className="ct_mt_20">
                                  <p className="text-end ct_fs_14 ct_darkblue_text">
                                    73%
                                  </p>
                                  <div class="progress ct_custom_progress ct_flex_1">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: "73%",
                                        backgroundColor: "var(--dark_blue)",
                                      }}
                                      aria-valuenow="73"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    ></div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Resume Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_1.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_7.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="pills-Rescheduled"
                      role="tabpanel"
                      aria-labelledby="pills-Rescheduled-tab"
                    >
                      <div className="row gx-5">
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_1.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>
                                <div className="ct_mt_20">
                                  <p className="text-end ct_fs_14 ct_darkblue_text">
                                    73%
                                  </p>
                                  <div class="progress ct_custom_progress ct_flex_1">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: "73%",
                                        backgroundColor: "var(--dark_blue)",
                                      }}
                                      aria-valuenow="73"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    ></div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Resume Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_2.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_3.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_4.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>
                                <div className="ct_mt_20">
                                  <p className="text-end ct_fs_14 ct_darkblue_text">
                                    73%
                                  </p>
                                  <div class="progress ct_custom_progress ct_flex_1">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: "73%",
                                        backgroundColor: "var(--dark_blue)",
                                      }}
                                      aria-valuenow="73"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    ></div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Resume Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_5.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_1.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_6.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>
                                <div className="ct_mt_20">
                                  <p className="text-end ct_fs_14 ct_darkblue_text">
                                    73%
                                  </p>
                                  <div class="progress ct_custom_progress ct_flex_1">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: "73%",
                                        backgroundColor: "var(--dark_blue)",
                                      }}
                                      aria-valuenow="73"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    ></div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Resume Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_1.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_7.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="pills-UI_UX_Design"
                      role="tabpanel"
                      aria-labelledby="pills-UI_UX_Design-tab"
                    >
                      <div className="row gx-5">
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_1.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>
                                <div className="ct_mt_20">
                                  <p className="text-end ct_fs_14 ct_darkblue_text">
                                    73%
                                  </p>
                                  <div class="progress ct_custom_progress ct_flex_1">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: "73%",
                                        backgroundColor: "var(--dark_blue)",
                                      }}
                                      aria-valuenow="73"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    ></div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Resume Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_2.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_3.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_4.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>
                                <div className="ct_mt_20">
                                  <p className="text-end ct_fs_14 ct_darkblue_text">
                                    73%
                                  </p>
                                  <div class="progress ct_custom_progress ct_flex_1">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: "73%",
                                        backgroundColor: "var(--dark_blue)",
                                      }}
                                      aria-valuenow="73"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    ></div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Resume Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_5.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_1.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_6.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>
                                <div className="ct_mt_20">
                                  <p className="text-end ct_fs_14 ct_darkblue_text">
                                    73%
                                  </p>
                                  <div class="progress ct_custom_progress ct_flex_1">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: "73%",
                                        backgroundColor: "var(--dark_blue)",
                                      }}
                                      aria-valuenow="73"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    ></div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Resume Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_1.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 ct_mb_60">
                          <div className="ct_learning_card_learning">
                            <figure className="mb-0">
                              <div className="ct_learning_card_img_aspext_ratio">
                                <img
                                  src="../assets/img/leaning_coaurce_img_7.png"
                                  className="ct_img_h_183 ct_border_radius_20"
                                />
                              </div>
                              <figcaption className="ct_mt_33">
                                <h4 className="ct_fs_28 mb-3 ct_darkblue_text">
                                  System design in Figma
                                </h4>
                                <p
                                  className="mb-0"
                                  style={{ maxWidth: "350px" }}
                                >
                                  You will learn how to create user-friendly and
                                  efficient interfaces for large systems.
                                </p>
                                <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_20">
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      4 hours
                                    </span>
                                  </li>
                                  <li>
                                    <span
                                      className="ct_badge border-0 ct_darkblue_text "
                                      style={{
                                        backgroundColor: "#DFDFDF",
                                        padding: "3px 10px",
                                      }}
                                    >
                                      10 hours
                                    </span>
                                  </li>
                                </ul>

                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                                  <div className="ct_icon_heart_50">
                                    <i class="fa-solid fa-heart ct_darkblue_text"></i>
                                  </div>
                                  <button className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 ct_px_60">
                                    Start Course
                                  </button>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="ct_px_40 ct_py_130 pt-0">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="ct_fs_40 text-center mb-0">
                    Meet Our Coaches
                  </h2>
                </div>
              </div>
              <div
                className="row ct_mt_60"
                data-aos="fade-down"
                data-aos-duration="1500"
              >
                <Swiper
                  modules={[Navigation, Autoplay, Pagination]}
                  loop={true}
                  slidesPerView={5}
                  spaceBetween={30}
                  navigation
                  pagination={{ clickable: true }}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    576: { slidesPerView: 2 },
                    768: { slidesPerView: 4 },
                    1200: { slidesPerView: 5 },
                  }}
                  className="ct_become_coach_slider"
                >
                  <SwiperSlide>
                    <figure className="ct_featured_coach_card">
                      <div className="ct_featured_card_img">
                        <img
                          src="../assets/img/Featured_Coaches_img_9.png"
                          alt=""
                        />
                      </div>
                      <figcaption>
                        <h4 className="ct_fs_20  mb-1">Jeffrey Walters</h4>
                        <p className="mb-0 ct_grey_text">
                          UI/UX Designer Coach
                        </p>
                      </figcaption>
                    </figure>
                  </SwiperSlide>
                  <SwiperSlide>
                    <figure className="ct_featured_coach_card">
                      <div className="ct_featured_card_img">
                        <img
                          src="../assets/img/Featured_Coaches_img_2.jpg"
                          alt=""
                        />
                      </div>
                      <figcaption>
                        <h4 className="ct_fs_20  mb-1">Joe Bridges</h4>
                        <p className="mb-0 ct_grey_text">Leadership Coach</p>
                      </figcaption>
                    </figure>
                  </SwiperSlide>
                  <SwiperSlide>
                    <figure className="ct_featured_coach_card">
                      <div className="ct_featured_card_img">
                        <img
                          src="../assets/img/Featured_Coaches_img_10.png"
                          alt=""
                        />
                      </div>
                      <figcaption>
                        <h4 className="ct_fs_20  mb-1">Nellie Padilla</h4>
                        <p className="mb-0 ct_grey_text">Personal Coach</p>
                      </figcaption>
                    </figure>
                  </SwiperSlide>
                  <SwiperSlide>
                    <figure className="ct_featured_coach_card">
                      <div className="ct_featured_card_img">
                        <img
                          src="../assets/img/Featured_Coaches_img_4.jpg"
                          alt=""
                        />
                      </div>
                      <figcaption>
                        <h4 className="ct_fs_20  mb-1">Jeffrey Walters</h4>
                        <p className="mb-0 ct_grey_text">Founder Coach</p>
                      </figcaption>
                    </figure>
                  </SwiperSlide>
                  <SwiperSlide>
                    <figure className="ct_featured_coach_card">
                      <div className="ct_featured_card_img">
                        <img
                          src="../assets/img/Featured_Coaches_img_5.jpg"
                          alt=""
                        />
                      </div>
                      <figcaption>
                        <h4 className="ct_fs_20  mb-1">Dean Bell</h4>
                        <p className="mb-0 ct_grey_text">Frontend Coach</p>
                      </figcaption>
                    </figure>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </section>

          <section
            class="ct_looking_for_work_bg ct_looking_for_work_bg_left     ct_p_111_y_106"
            data-aos="fade-left"
            data-aos-duration="1500"
            style={{ backgroundColor: "var(--orange)" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">
                  Learn from the Best, Grow with Purpose
                </h4>
                <p class="mb-0 ct_fs_18">
                  Expert-led insights, tools, and resources to help you thrive
                  at every stage.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={openSignUp}
                >
                  Join Us
                </a>
              </div>
            </div>
          </section>

          <section class=" ct_py_130 ct_px_40">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <h2 class="ct_fs_40 ct_pb_60  text-center mb-0 ct_darkblue_text">
                    Power Your Learning with the Right Plan
                  </h2>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                  data-aos="fade-down"
                  data-aos-duration="1000"
                >
                  <h4 class="ct_yellow_text  ct_fs_35 mb-3">NuGlow</h4>

                  <figure class="mb-0 ct_coach_created_card ct_coach_created_w_90">
                    <div
                      class="ct_coach_created_img"
                      style={{ aspectRatio: "auto" }}
                    >
                      <img
                        alt=""
                        src="../assets/img/Rectangle_first.png"
                        className="ct_img_h_267"
                      />
                    </div>
                    <figcaption class="mt-3">
                      <p
                        class="mb-0 ct_darkblue_text ct_fs_20 ct_para_scroll ct_custom_scroll"
                        style={{ maxWidth: "368px" }}
                      >
                        Build strong foundations and gain hands-on experience
                        with guided learning and beginner-friendly resources.
                      </p>
                      <div className="mt-3">
                        <a
                          class="ct_yellow_btn ct_fit_content ct_h_44 px-4"
                          onClick={() =>
                            navigate(coachPaths?.NuGlowSubscription)
                          }
                        >
                          Learn More{" "}
                          <i class="fa-solid fa-arrow-right ms-2"></i>
                        </a>
                      </div>
                    </figcaption>
                  </figure>
                </div>
                <div
                  class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <h4 class="ct_orange_text  ct_fs_32 mb-3">NuForge</h4>

                  <figure class="mb-0 ct_coach_created_card ct_coach_created_w_90">
                    <div
                      class="ct_coach_created_img"
                      style={{ aspectRatio: "auto" }}
                    >
                      <img
                        alt=""
                        src="/assets/img/Rectangle_second.png"
                        className="ct_img_h_267"
                      />
                    </div>
                    <figcaption class="mt-3">
                      <p
                        class="mb-0 ct_darkblue_text ct_fs_20 ct_para_scroll ct_custom_scroll"
                        style={{ maxWidth: "368px" }}
                      >
                        Refine your skills, expand your reach, and learn from
                        experts to level up your freelance career advanced
                        freelancers.
                      </p>
                      <div className="mt-3">
                        <a
                          class="ct_yellow_btn ct_fit_content ct_h_44 px-4"
                          onClick={() =>
                            navigate(coachPaths?.NuForgeSubscription)
                          }
                        >
                          Learn More{" "}
                          <i class="fa-solid fa-arrow-right ms-2"></i>
                        </a>
                      </div>
                    </figcaption>
                  </figure>
                </div>
                <div
                  class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                  data-aos="fade-down"
                  data-aos-duration="2000"
                >
                  <h4 class="ct_darksky_blue_text  ct_fs_32 mb-3">NuStar</h4>

                  <figure class="mb-0 ct_coach_created_card ct_coach_created_w_90">
                    <div
                      class="ct_coach_created_img"
                      style={{ aspectRatio: "auto" }}
                    >
                      <img
                        alt=""
                        src="/assets/img/Rectangle_third.png"
                        className="ct_img_h_267"
                      />
                    </div>
                    <figcaption class="mt-3">
                      <p
                        class="mb-0 ct_darkblue_text ct_fs_20 ct_para_scroll ct_custom_scroll"
                        style={{ maxWidth: "368px" }}
                      >
                        Unlock advanced insights, elite mentorship, and premium
                        content tailored for top-tier professionals.
                      </p>
                      <div className="mt-3">
                        <a
                          class="ct_yellow_btn ct_fit_content ct_h_44 px-4"
                          onClick={() =>
                            navigate(coachPaths?.NuStarSubscription)
                          }
                        >
                          Learn More{" "}
                          <i class="fa-solid fa-arrow-right ms-2"></i>
                        </a>
                      </div>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>
          </section>

          <section
            className="ct_px_40 pt-0 pb-0"
            data-aos="fade-down"
            data-aos-duration="1500"
          >
            <div className="container-fluid">
              {/* convert into slider */}
              <div className="row">
                <div className="col-lg-4 col-md-6 mb-4">
                  <div class="ct_testimonial_review_card h-100 d-grid">
                    <div>
                      <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                        <div class="d-flex align-items-center gap-1">
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        </div>
                        <p className="mb-0 ct_fs_16">20th April, 2025</p>
                      </div>
                      <p className="mb-0 " style={{ maxWidth: "295px" }}>
                        The expert sessions and networking inside NuForge are next level. I finally feel part of a serious community that pushes me to grow.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div class="d-flex align-items-center gap-3 ct_mt_40">
                        <img
                          src="/assets/img/Ellipse 24.png"
                          class="ct_img_60 "
                          alt=""
                        />
                        <div>
                          <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                            Alex Robertson
                          </h5>
                          <p class="mb-0  ct_fs_16  ">Frontend Developer</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4">
                  <div class="ct_testimonial_review_card h-100 d-grid">
                    <div>
                      <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                        <div class="d-flex align-items-center gap-1">
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        </div>

                        <p className="mb-0 ct_fs_16">20th April, 2025</p>
                      </div>
                      <p className="mb-0 " style={{ maxWidth: "295px" }}>
                        With NuForge, I refined my services, rebranded my profile, and doubled my client reach in just a few weeks. Totally worth it!
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div class="d-flex align-items-center gap-3 ct_mt_40">
                        <img
                          src="/assets/img/Ellipse 24 (1).png"
                          class="ct_img_60 "
                          alt=""
                        />
                        <div>
                          <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                            Olivia Brooks
                          </h5>
                          <p class="mb-0  ct_fs_16  ">Mobile App Developer</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4">
                  <div class="ct_testimonial_review_card h-100 d-grid">
                    <div>
                      <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                        <div class="d-flex align-items-center gap-1">
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        </div>

                        <p className="mb-0 ct_fs_16">20th April, 2025</p>
                      </div>
                      <p className="mb-0 " style={{ maxWidth: "295px" }}>
                        NuForge helped me position myself for higher-paying clients by improving my portfolio and strategy.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div class="d-flex align-items-center gap-3 ct_mt_40">
                        <img
                          src="/assets/img/Ellipse 24 (2).png"
                          class="ct_img_60 "
                          alt=""
                        />
                        <div>
                          <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                            James Thornton
                          </h5>
                          <p class="mb-0  ct_fs_16  ">Cloud Solutions Architect</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* <footer class="ct_px_40 py-5">
        <div class="ct_footer_logo">
          <a>
            <img src="assets/img/Nuvio_logo.png" alt="" />
          </a>
        </div>
        <div class="row pt-4">
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Navigation</h4>
              <ul>
                <li>
                  <a>For Enterprises</a>
                </li>
                <li>
                  <a>For Freelancers</a>
                </li>
                <li>
                  <a>CoachHUB</a>
                </li>
                <li>
                  <a>Funding</a>
                </li>
                <li>
                  <a>About us</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Resources</h4>
              <ul>
                <li>
                  <a>Blog</a>
                </li>
                <li>
                  <a>Newsletter</a>
                </li>
                <li>
                  <a>Tutorials</a>
                </li>
                <li>
                  <a>Support</a>
                </li>
                <li>
                  <a>Help Centre</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-2 col-xl-3 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Get in Touch</h4>
              <ul>
                <li>
                  <a href="mailto:hello@nu-vio.com">
                    <i class="fa-solid fa-envelope me-1 ct_yellow_text"></i>
                    hello@nu-vio.com
                  </a>
                </li>
                <li>
                  <a href="tel:+123-456-789">
                    <i class="fa-solid fa-phone me-1 ct_yellow_text"></i>
                    +123-456-789
                  </a>
                </li>
                <li>
                  <a>
                    <i class="fa-solid fa-location-dot ct_yellow_text me-1"></i>{" "}
                   Office 36, 1 Exchange Building (TBE), Cybercity, Ebene Mauritius
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-4 col-xl-5 col-md-6 mb-4">
            <div class="ct_newsletter_bg">
              <p>Ready to keep up with what’s next?</p>
              <div class="d-flex align-items-center gap-2 justify-content-between ct_flex_col_991">
                <div class="form-group ct_flex_1 ct_w_100_991">
                  <input
                    type="email"
                    class="form-control ct_input ct_border_radius_100"
                    placeholder="Enter your email address"
                  />
                </div>
                <div class="ct_w_100_991">
                  <button class="ct_yellow_btn ct_darkblue_btn ct_border_radius_100 ct_h_48 ct_w_100_991">
                    Subscribe now
                  </button>
                </div>
              </div>
            </div>
            <div class="pt-4">
              <h5 class="ct_fs_18 mb-3">Follow Us</h5>
              <div class="d-flex align-items-center gap-2">
                <a style={{ color: "#0076B2" }}>
                  <i class="fa-brands fa-linkedin"></i>
                </a>
                <a style={{ color: "#3D5A98" }}>
                  <i class="fa-brands fa-square-facebook"></i>
                </a>
                <a style={{ color: "#FF0000" }}>
                  <i class="fa-brands fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-4 ct_border_top_1">
          <div class="col-md-12">
            <p class="mb-0 text-center">
              Copyright @ 2025 NUVIO All Rights Reserved
            </p>
          </div>
        </div>
      </footer> */}

          <div
            class="modal fade ct_submit_modal"
            id="ct_submit_modal"
            tabindex="-1"
            aria-labelledby="ct_submit_modalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-body py-5">
                  <div class="mx-auto d-block text-center mb-4">
                    <svg
                      width="80"
                      height="80"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                        fill="#FFB703"
                      />
                    </svg>
                  </div>
                  <div class="text-center">
                    <h4 class="ct_fs_20 ">Application Submitted</h4>
                    <p>
                      Thanks for applying to become a coach on Nuvio CoachHUB.
                      Our team is currently reviewing your application
                    </p>
                  </div>
                  <div class="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                    <a class="ct_yellow_btn ct_outline_grey ct_h_48 px-5 ct_w_100_575">
                      View Coaches
                    </a>
                    <button
                      class="ct_yellow_btn ct_h_48  px-5 ct_w_100_575"
                      data-bs-dismiss="modal"
                    >
                      Close{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ height: "100px" }}></div>
        </>
      )}
    </MenuLayout>
  );
};

export default Learning;
